module.exports = __webpack_public_path__ + "img/after.fc7323db.png";